import { Vue, Component, Ref, Prop } from 'vue-property-decorator'

@Component({
    components: {
    }
})
export default class GroupsOfConceptsModalBasicForm extends Vue {
    @Ref() readonly groupsOfConceptsModalBasicForm!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.groupsOfConceptsModalBasicForm.show()
    }

    hide() {
        this.groupsOfConceptsModalBasicForm.hide()
    }
}
